import ContextoService from '../../services/Contexto';

export const GET_PERIODOS = 'SET_PERIODOS';

export function setPeriodos(periodos) {
    return {
        type: GET_PERIODOS,
        periodos
    }
}

export function loadPeriodos() {
    return async dispatch => {
        return await ContextoService.periodos()
                .then( res => {
                    dispatch ( setPeriodos(res.data) );
                });
    }
}